import "./Footer.css";

const year = new Date().getFullYear();

export function Footer(): JSX.Element {
    return (
        <div className="Footer">
			<p>All rights reserved to &copy; LoopyDoopy {year}</p>
        </div>
    );
}
